// extracted by mini-css-extract-plugin
export default {"friendList":"FriendList_friendList__aVc4P"};